// ================================================================
// vm-clamped-text
//
// Slotted text clamped to N lines with an absolutely-positioned
// "...read more" button. Wraps a fade gradient that blends into the
// host background — caller sets --vm-clamped-text-bg to match.
//
// BEM block: vm-clamped-text
// ================================================================

:host {
    display: block;
    position: relative;
    --vm-clamped-text-bg: transparent;
}

.vm-clamped-text {
    &__body {
        margin: 0;
        white-space: normal;

        &:not(.vm-clamped-text__body--expanded) {
            display: -webkit-box;
            -webkit-line-clamp: var(--vm-clamped-text-lines, 3);
            line-clamp: var(--vm-clamped-text-lines, 3);
            -webkit-box-orient: vertical;
            overflow: hidden;
        }
    }

    &__read-more {
        position: absolute;
        right: 0;
        bottom: 0;
        margin: 0;
        padding: 0 0 0 32px;
        border: 0;
        background: linear-gradient(to right, transparent, var(--vm-clamped-text-bg) 24px);
        font: inherit;
        color: inherit;
        cursor: pointer;
        font-weight: 700;
    }
}

slot {
    white-space: pre-wrap;
}
